import React from 'react'
import { Box, Button, Drawer, Typography, useTheme } from '@mui/material'

export const GenericDrawer = ({
  open,
  onClose,
  onSubmit,
  children,
  title = 'Drawer',
  submitLabel = 'Submit',
  cancelLabel = 'Cancel',
  width = '400px',
  disabled = false,
  showActionButtons = true,
  ...rest
}) => {
  const theme = useTheme()

  return (
    <Drawer
      anchor='right'
      open={open}
      onClose={onClose}
      sx={{ '& .MuiDrawer-paper': { width } }}
      {...rest}
    >
      <Box component='form' onSubmit={onSubmit} sx={{ pb: 2 }}>
        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: theme.palette.secondary.light,
            p: 2,
            borderBottom: `2px solid ${theme.palette.divider}`,
            mb: 1,
          }}
        >
          <Typography variant='subtitle1' component='h2' sx={{ fontWeight: 'bold' }}>
            {title}
          </Typography>
        </Box>

        {/* Content */}
        <Box sx={{ p: 2 }}>{children}</Box>
        
        {/* Action Buttons */}
        {showActionButtons && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, px: 2, mt: 2 }}>
            <Button onClick={onClose}>{cancelLabel}</Button>
            <Button type='submit' variant='contained' disabled={disabled}>
              {submitLabel}
            </Button>
          </Box>
        )}
      </Box>
    </Drawer>
  )
}

export default GenericDrawer
